import styled from 'styled-components';

export const SlotPickerContainer = styled.div`
  --slot-accent-soft: color-mix(in srgb, var(--slot-accent, #4f46e5) 9%, #ffffff);
  --slot-accent-line: color-mix(in srgb, var(--slot-accent, #4f46e5) 35%, #ffffff);

  width: 100%;
  margin: 12px 0;
  container-type: inline-size;

  &.datepicker-wrapper {
    display: block;
  }

  .datepicker-grid {
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
    overflow: hidden;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background: #ffffff;
  }

  .datepicker {
    min-width: 0;
    padding: 20px;
  }

  .datepicker + .datepicker {
    border-left: 1px solid #eef0f3;
  }

  .datepicker.time-section {
    display: flex;
    flex-direction: column;
    min-height: 360px;
  }

  .datepicker-title {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.4;
    color: #111827;
  }

  .datepicker-subtitle {
    margin: 2px 0 16px;
    font-size: 13px;
    line-height: 1.4;
    color: #6b7280;
  }

  .time-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;

    .datepicker-subtitle {
      margin-bottom: 12px;
    }
  }

  .time-count {
    flex-shrink: 0;
    padding: 3px 9px;
    border-radius: 999px;
    background: #f3f4f6;
    font-size: 12px;
    font-weight: 500;
    color: #4b5563;
  }

  .datepicker-calendar {
    width: 100%;
    max-width: 340px;
    margin: 0 auto;

    .MuiPickersCalendarHeader-root {
      padding-left: 12px;
      padding-right: 4px;
    }

    .MuiPickersCalendarHeader-label {
      font-size: 14px;
      font-weight: 600;
      color: #111827;
    }

    .MuiDayCalendar-weekDayLabel {
      font-size: 12px;
      font-weight: 600;
      color: #9ca3af;
    }

    .MuiPickersDay-root {
      font-size: 13px;
    }

    .MuiPickersDay-root.Mui-disabled:not(.Mui-selected) {
      color: #c4c8cf;
    }

    .MuiPickersDay-root.has-slots {
      background-color: var(--slot-accent-soft);
      color: var(--slot-accent, #4f46e5);
      font-weight: 600;
    }

    .MuiPickersDay-root.has-slots:hover {
      background-color: var(--slot-accent-line);
    }

    .MuiPickersDay-root.Mui-selected,
    .MuiPickersDay-root.Mui-selected:hover,
    .MuiPickersDay-root.Mui-selected:focus {
      background-color: var(--slot-accent, #4f46e5);
      color: #ffffff;
    }
  }

  .timezone-select {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    padding: 0 4px 0 10px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #f9fafb;
    color: #6b7280;

    svg {
      flex-shrink: 0;
    }

    .MuiInputBase-root {
      flex: 1;
      min-width: 0;
      font-family: inherit;
      font-size: 13px;
      color: #374151;
    }

    .MuiSelect-select {
      padding: 8px 24px 8px 0;
      background: transparent;
    }
  }

  .time-slots-container {
    max-height: 264px;
    overflow-y: auto;
    padding: 2px 4px 2px 2px;
  }

  .time-slots-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(104px, 1fr));
    gap: 8px;
  }

  .time-slot-button {
    width: 100%;
    height: 38px;
    padding: 0 8px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 1px 1px rgba(16, 24, 40, 0.04);
    color: #1f2937;
    font-family: inherit;
    font-size: 13.5px;
    font-weight: 500;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
    text-transform: none;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;

    &:hover:not(:disabled):not(.selected) {
      border-color: var(--slot-accent, #4f46e5);
      background: var(--slot-accent-soft);
      color: var(--slot-accent, #4f46e5);
    }

    &:focus-visible {
      outline: 2px solid var(--slot-accent, #4f46e5);
      outline-offset: 2px;
    }

    &.selected {
      border-color: var(--slot-accent, #4f46e5);
      background: var(--slot-accent, #4f46e5);
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.12);
      color: #ffffff;
      font-weight: 600;
    }

    &:disabled {
      cursor: default;
      opacity: 0.55;
    }
  }

  .selected-slot-summary {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 16px 0 0;
    padding: 10px 12px;
    border: 1px solid var(--slot-accent-line);
    border-radius: 8px;
    background: var(--slot-accent-soft);
    font-size: 13px;
    line-height: 1.4;
    color: #374151;

    svg {
      flex-shrink: 0;
      color: var(--slot-accent, #4f46e5);
    }

    strong {
      font-weight: 600;
      color: #111827;
    }
  }

  .empty-message {
    margin: 32px 0 0;
    text-align: center;
    font-size: 13px;
    color: #9ca3af;
  }

  .center-box {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 280px;
    padding: 0 12px;
    text-align: center;
    font-size: 13.5px;
    line-height: 1.5;
    color: #6b7280;

    svg {
      color: #c4c8cf;
    }
  }

  .center-box.error,
  .loader-text.error {
    color: #d32f2f;
  }

  .loader-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    min-height: 360px;
  }

  .loader-text {
    font-size: 0.95rem;
    color: #666666;
  }

  @container (max-width: 640px) {
    .datepicker-grid {
      grid-template-columns: minmax(0, 1fr);
    }

    .datepicker {
      padding: 16px;
    }

    .datepicker + .datepicker {
      border-left: 0;
      border-top: 1px solid #eef0f3;
    }

    .datepicker.time-section {
      min-height: 0;
    }

    .center-box {
      min-height: 160px;
    }
  }
`;
